import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container, Tabs, Tab } from '@mui/material';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const Navbar: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    auth.logout();
    navigate('/login');
  };

  // Проверяем, находится ли пользователь на странице входа или обзора
  const isLoginPage = location.pathname === '/login';
  const isReviewPage = location.pathname.startsWith('/review/');
  
  // Определяем активную вкладку
  const getActiveTab = () => {
    if (location.pathname === '/') return 0;
    if (location.pathname === '/notebooks') return 1;
    if (location.pathname === '/lectures' || location.pathname.startsWith('/lectures/')) return 2;

    if (location.pathname === '/datasets' || location.pathname.startsWith('/datasets/')) return 3;
    return false;
  };

  return (
    <AppBar 
      position="sticky" 
      sx={{ 
        backgroundColor: 'white', 
        color: 'text.primary',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
      }}
    >
      <Container maxWidth="lg" sx={{ px: 0 }}>
        <Toolbar sx={{ px: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
            <img 
              src="/logo.ico" 
              alt="DeepSchool Logo" 
              style={{ 
                width: '32px', 
                height: '32px', 
                marginRight: '10px' 
              }} 
            />
            <Typography variant="h6" component={Link} to="/" sx={{ 
              textDecoration: 'none', 
              color: 'inherit',
              fontWeight: 'bold'
            }}>
              DeepSchool Review
            </Typography>
          </Box>
          
          {auth.user && !isReviewPage && !isLoginPage && (
            <Tabs 
              value={getActiveTab()} 
              sx={{ ml: 4 }}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab 
                label="Загрузка ноутбука" 
                component={Link} 
                to="/" 
                sx={{ textTransform: 'none' }}
              />
              <Tab 
                label="Список ноутбуков" 
                component={Link} 
                to="/notebooks" 
                sx={{ textTransform: 'none' }}
              />
              <Tab
                label="Лекции"
                component={Link}
                to="/lectures"
                sx={{ textTransform: 'none' }}
              />
              <Tab 
                label="Датасеты" 
                component={Link} 
                to="/datasets" 
                sx={{ textTransform: 'none' }}
              />
            </Tabs>
          )}
          
          <Box sx={{ flexGrow: 1 }} />
          
          {auth.user && !isReviewPage ? (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" sx={{ mr: 2 }}>
                {auth.user.username}
              </Typography>
              <Button 
                variant="text" 
                sx={{ 
                  color: 'text.primary',
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 'normal'
                }} 
                onClick={handleLogout}
              >
                Выйти
              </Button>
            </Box>
          ) : (
            <Box>
              {!isLoginPage && !isReviewPage && (
                <Button 
                  variant="text" 
                  sx={{ 
                    color: 'text.primary',
                    textTransform: 'none',
                    fontSize: '1rem',
                    fontWeight: 'normal'
                  }} 
                  component={Link} 
                  to="/login"
                >
                  Войти
                </Button>
              )}
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}; 